/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Click_Drag_Create_Events_HelpInputs */

const en_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new Events by click-n-dragging on the Timeline.`)
};

const fr_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer de nouveaux événements en cliquant-glissant sur la timeline.`)
};

const de_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisse erstellen Sie durch Klicken und Ziehen auf der Zeitleiste.`)
};

const it_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea nuovi eventi cliccando e trascinando sulla sequenza temporale.`)
};

const ru_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создавайте новые события, перетаскивая курсор мыши по временной шкале.`)
};

const es_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree nuevos eventos haciendo clic y arrastrando en la línea de tiempo.`)
};

const zh_cn2_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在时间轴上点击并拖动即可创建新事件。`)
};

const ja_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムライン上でクリックしてドラッグして新しいイベントを作成します。`)
};

const hi_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन पर क्लिक करके और ड्रैग करके नए इवेंट बनाएं।`)
};

const pt_pt2_options_editor_click_drag_create_events_help = /** @type {(inputs: Options_Editor_Click_Drag_Create_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie novos eventos clicando e arrastando na Linha do Tempo.`)
};

/**
* | output |
* | --- |
* | "Create new Events by click-n-dragging on the Timeline." |
*
* @param {Options_Editor_Click_Drag_Create_Events_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_click_drag_create_events_help = /** @type {((inputs?: Options_Editor_Click_Drag_Create_Events_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Click_Drag_Create_Events_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_click_drag_create_events_help(inputs)
	if (locale === "de") return de_options_editor_click_drag_create_events_help(inputs)
	if (locale === "it") return it_options_editor_click_drag_create_events_help(inputs)
	if (locale === "ru") return ru_options_editor_click_drag_create_events_help(inputs)
	if (locale === "es") return es_options_editor_click_drag_create_events_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_click_drag_create_events_help(inputs)
	if (locale === "ja") return ja_options_editor_click_drag_create_events_help(inputs)
	if (locale === "hi") return hi_options_editor_click_drag_create_events_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_click_drag_create_events_help(inputs)
	return en_options_editor_click_drag_create_events_help(inputs)
});